module.exports = __webpack_public_path__ + "media/components/assets/img/bg/airport-lp-0bb5e6d3d954ae813645159359cf649b.svg";